import { useEffect, useMemo } from 'react';

import { calendarFilter } from '@pharmaplan/common/selectors/calendarSelector';
import { pharmacistMap } from '@pharmaplan/common/selectors/pharmacistSelector';

import { useAppSelector } from '../useAppSelector';

const usePharmacistMapZoomFilter = (map: any, maps: any) => {
  const filter = useAppSelector(calendarFilter);
  const emptyFilter = {
    banners: [],
    softwares: [],
    cities: [],
    minHourRate: '',
    weekVolume: null,
    weekendVolume: null,
  };

  const mapEvents = useAppSelector(pharmacistMap);
  const onlyLatLng = useMemo(
    () =>
      mapEvents
        .filter(
          (event) =>
            event.latitude != null
          && event.longitude != null
          && !Number.isNaN(Number(event.latitude))
          && !Number.isNaN(Number(event.longitude)),
        )
        .map((event) =>
          ({
            lat: Number(event.latitude),
            lng: Number(event.longitude),
          })),
    [mapEvents],
  );

  const zoomToFitMarkers = () => {
    if (map && maps && onlyLatLng.length > 0) {
      const bounds = new maps.LatLngBounds();

      onlyLatLng.forEach((c) =>
        bounds.extend(c));

      map.fitBounds(bounds);
    }
  };

  useEffect(() => {
    const isFilterApplied = JSON.stringify(filter) !== JSON.stringify(emptyFilter);
    if (isFilterApplied) {
      setTimeout(() => {
        zoomToFitMarkers();
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
};

export default usePharmacistMapZoomFilter;
